import createReducer from '../createReducer'
import { RELOAD_AUTH_SUCCESS } from 'services/auth/constants'
import {
  CHECKOUT_LOADING,
  CHECKOUT_SUCCESS,
  CHECKOUT_ERROR,
  CHECKOUT_PAGE_LOADING,
  CHECKOUT_PAGE_SUCCESS,
  CHECKOUT_PAGE_ERROR,
  FETCH_BILLING_PROFILES_SUCCESS,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_ERROR,
  SELECT_PRODUCT,
  FETCH_PAID_SUBSCRIPTIONS_SUCCESS,
  DELETE_BILLING_PROFILE_LOADING,
  ADD_CARD_LOADING,
  ADD_CARD_SUCCESS,
  ADD_CARD_ERROR,
  UPDATE_DEFAULT_BILLING_PROFILE_LOADING,
  UPDATE_DEFAULT_BILLING_PROFILE_SUCCESS,
  UPDATE_DEFAULT_BILLING_PROFILE_ERROR,
  SUBSCRIPTION_SETTINGS_LOADING,
  SUBSCRIPTION_SETTINGS_SUCCESS,
  CREATE_PAID_SUBSCRIPTION_LOADING,
  CREATE_BILLING_PROFILE_LOADING,
  CREATE_BILLING_PROFILE_SUCCESS,
  CREATE_BILLING_PROFILE_ERROR,
  UPDATE_AUTO_RENEW_LOADING,
  UPDATE_AUTO_RENEW_ERROR,
  UPDATE_AUTO_RENEW_SUCCESS,
  CREATE_USER_COUPON_SUCCESS,
  CREATE_USER_COUPON_ERROR,
  FETCH_COUPON_SUCCESS,
  FETCH_USER_COUPONS_SUCCESS,
  APPLY_COUPON_LOADING,
  APPLY_COUPON_SUCCESS,
  APPLY_COUPON_ERROR,
  UPDATE_BILLING_PROFILE_LOADING,
  UPDATE_BILLING_PROFILE_SUCCESS,
  ADD_BILLING_PROFILE_LOADING,
  ADD_BILLING_PROFILE_ERROR,
  ADD_BILLING_PROFILE_SUCCESS,
} from './constants'

export const initialState = {
  products: [],
  subscriptions: [],
  billingProfiles: [], // always get from api
  success: null,
  submitting: false,
  error: null,
  errorDescription: null,
  errorMessage: null,
  selectedProduct: null,
  purchasedSubscription: null,
  coupon: null,
  userCoupon: null,
  stripeKey: null,
  upsellURL: null,
  status: {
    result: {
      output: {
        is_ad_free: false,
        days_remaining: Number.NEGATIVE_INFINITY,
      },
    },
  },
}

export const unpackError = (action) => {
  let errorCode = 'unknown'
  let errorDescription = null

  if (action.payload && action.payload.response) {
    const { payload: { response: { data }}} = action
    if (data) {
      errorDescription = data.error_description
      if (data.error_details) {
        errorCode = data.error_details.code
      } else {
        errorCode = data.error
      }
    }
  }

  return { errorCode, error_description: errorDescription }
}

export default createReducer(initialState, {

  name: 'premium',

  [RELOAD_AUTH_SUCCESS]: (state, action) => {
    const { premiumStatus: { data: status }} = action.payload
    return { ...state, status }
  },

  [FETCH_COUPON_SUCCESS]: (state, action) => {
    const { payload: { data: { item: coupon }}} = action
    return { ...state, coupon }
  },

  [CREATE_USER_COUPON_SUCCESS]: (state, action) => {
    const { payload: { data: { item: userCoupon }}} = action
    return {
      ...state,
      userCoupon,
      success: true,
      submitting: false,
      errorMessage: null,
      error: false,
      error_description: null,
    }
  },

  [CREATE_USER_COUPON_ERROR]: (state, action) => {
    const { errorCode, error_description } = unpackError(action)
    return {
      ...state,
      error: true,
      errorCode,
      success: false,
      submitting: false,
      error_description,
    }
  },

  [SELECT_PRODUCT]: (state, action) => {
    const { payload: selectedProduct } = action
    return { ...state, selectedProduct }
  },

  [FETCH_PAID_SUBSCRIPTIONS_SUCCESS]: (state, action) => {
    const { payload: { data: { items: subscriptions }}} = action
    return { ...state, subscriptions }
  },

  [FETCH_PRODUCTS_SUCCESS]: (state, action) => {
    const { payload } = action
    const products = payload.map((result) => result.data.item)
    return {
      ...state,
      products: [...state.products, ...products],
    }
  },

  [FETCH_PRODUCTS_ERROR]: (state) => {
    return {
      ...state,
      error: true,
      errorCode: 'product_fetch/1',
    }
  },

  [APPLY_COUPON_LOADING]: (state, action) => {
    const attemptedCoupon = action.payload
    return {
      ...state,
      attemptedCoupon,
      submitting: true,
      submittingAction: 'apply_coupon',
    }
  },

  [APPLY_COUPON_SUCCESS]: (state) => {
    return { ...state, submitting: false }
  },

  [APPLY_COUPON_ERROR]: (state, action) => {
    const { errorCode, error_description } = unpackError(action)
    return {
      error: true,
      errorCode,
      error_description,
    }
  },

  [CHECKOUT_LOADING]: (state) => {
    return {
      ...state,
      success: false,
      error: null,
      error_description: null,
      errorMessage: null,
      submitting: true,
      submittingAction: 'checkout',
    }
  },

  [CHECKOUT_SUCCESS]: (state) => {
    return {
      ...state,
      success: true,
      submitting: false,
      errorMessage: null,
      error: false,
      error_description: null,
    }
  },

  [CHECKOUT_ERROR]: (state, action) => {
    const { errorCode, error_description } = unpackError(action)
    return {
      ...state,
      errorCode,
      error: true,
      success: false,
      submitting: false,
      error_description,
    }
  },

  [CREATE_PAID_SUBSCRIPTION_LOADING]: (state) => {
    return {
      ...state,
      submitting: true,
      submittingAction: 'create_paid_subscription',
    }
  },

  [DELETE_BILLING_PROFILE_LOADING]: (state, action) => {
    const deletedId = action.payload
    const billingProfiles = state.billingProfiles.filter((profile) => {
      return profile.billing_profile_id !== deletedId
    })

    if (billingProfiles.length === 1) {
      billingProfiles[0].default = true
    }

    return { ...state, billingProfiles }
  },

  [FETCH_BILLING_PROFILES_SUCCESS]: (state, action) => {
    const { payload: { data: { items: billingProfiles }}} = action
    billingProfiles.sort((a) => { return a.default ? -1 : 1 })
    return { ...state, billingProfiles }
  },

  [ADD_CARD_LOADING]: (state) => {
    return {
      ...state,
      error: null,
      error_description: null,
      errorMessage: null,
      submittingAction: 'add_card',
    }
  },

  [ADD_CARD_SUCCESS]: (state, action) => {
    const { payload: { value: { data: { item: newProfile }}}} = action
    const billingProfiles = [...state.billingProfiles, newProfile]
    return { ...state, billingProfiles }
  },

  [ADD_CARD_ERROR]: (state, action) => {
    const { errorCode, error_description } = unpackError(action)
    return {
      ...state,
      errorCode,
      error: true,
      success: false,
      error_description,
    }
  },

  [ADD_BILLING_PROFILE_LOADING]: (state) => {
    return { ...state, submitting: true }
  },

  [ADD_BILLING_PROFILE_ERROR]: (state) => {
    return { ...state, submitting: false }
  },

  [ADD_BILLING_PROFILE_SUCCESS]: (state) => {
    return { ...state, submitting: false }
  },

  [CREATE_BILLING_PROFILE_LOADING]: (state) => {
    return {
      ...state,
      error: null,
      error_description: null,
      errorMessage: null,
      billingProfileSuccess: null,
    }
  },

  [CREATE_BILLING_PROFILE_SUCCESS]: (state) => {
    return {
      ...state,
      error: false,
      errorMessage: null,
      error_description: null,
      billingProfileSuccess: true,
    }
  },

  [CREATE_BILLING_PROFILE_ERROR]: (state, action) => {
    const { errorCode, error_description } = unpackError(action)
    return {
      ...state,
      error: true,
      errorCode,
      error_description,
      billingProfileSuccess: false,
    }
  },

  [UPDATE_DEFAULT_BILLING_PROFILE_LOADING]: (state, action) => {
    const updatedId = action.payload
    const billingProfiles = state.billingProfiles.map((profile) => {
      return {
        ...profile,
        default: profile.billing_profile_id === updatedId,
      }
    })

    return { ...state, billingProfiles, updatingBillingProfile: true }
  },

  [UPDATE_DEFAULT_BILLING_PROFILE_SUCCESS]: (state) => {
    return { ...state, updatingBillingProfile: false }
  },

  [UPDATE_DEFAULT_BILLING_PROFILE_ERROR]: (state) => {
    return { ...state, updatingBillingProfile: false }
  },

  [UPDATE_AUTO_RENEW_LOADING]: (state, action) => {
    const { payload: { subscriptionId, autoRenewal }} = action

    return {
      ...state,
      autoRenewalPendingBool: autoRenewal,
      autoRenewalPendingId: subscriptionId,
      autoRenewalLoading: true,
      autoRenewalError: false,
      autoRenewalSuccess: false,
    }
  },

  [UPDATE_AUTO_RENEW_ERROR]: (state) => {
    return { ...state, autoRenewalLoading: false, autoRenewalError: true }
  },

  [UPDATE_AUTO_RENEW_SUCCESS]: (state) => {
    const { autoRenewalPendingId, autoRenewalPendingBool } = state
    const subscriptions = state.subscriptions.map((sub) => {
      const matches = sub.subscription_id === autoRenewalPendingId
      return matches ? { ...sub, requested_cancellation: !autoRenewalPendingBool } : sub
    })

    return { ...state, subscriptions, autoRenewalLoading: false, autoRenewalSuccess: true }
  },

  [CHECKOUT_PAGE_LOADING]: (state) => {
    return { ...state, checkoutPageLoading: true, loadError: false }
  },

  [CHECKOUT_PAGE_SUCCESS]: (state) => {
    return { ...state, checkoutPageLoading: false, loadError: false }
  },

  [CHECKOUT_PAGE_ERROR]: (state) => {
    return { ...state, checkoutPageLoading: false, loadError: true }
  },

  [SUBSCRIPTION_SETTINGS_LOADING]: (state) => {
    return { ...state, subscriptionSettingsLoading: true }
  },

  [SUBSCRIPTION_SETTINGS_SUCCESS]: (state) => {
    return { ...state, subscriptionSettingsLoading: false }
  },

  [FETCH_USER_COUPONS_SUCCESS]: (state, action) => {
    const { payload: { data: { items: userCoupons }}} = action
    return { ...state, userCoupons }
  },

  [UPDATE_BILLING_PROFILE_LOADING]: (state, action) => {
    const pendingNewProfile = action.payload

    return {
      ...state,
      error: false,
      submitting: true,
      submittingAction: 'update_billing_profile',
      pendingNewProfile,
    }
  },

  [UPDATE_BILLING_PROFILE_SUCCESS]: (state) => {
    const pendingNewProfile = state.pendingNewProfile
    const billingProfiles = state.billingProfiles.map((profile) => {
      if (profile.billing_profile_id === pendingNewProfile.billing_profile_id) {
        return pendingNewProfile
      }
      return profile
    })

    return {
      ...state,
      submitting: false,
      error: false,
      billingProfiles,
    }
  },

})
